module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-5.28f566ae.webp";